'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _themeCart = require('@shopify/theme-cart');

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if ((0, _themeCart.cookiesEnabled)()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

// Mega Drop Menu
var megaButton = document.querySelector('[data-megamenu-button]');
megaButton.addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();

  if (document.body.classList.contains('mega--open') && megaButton.classList.contains('active')) {
    closeMegaMenu();
  } else {
    document.body.classList.add('mega--open');
    megaButton.classList.add('active');
  }
});

document.body.addEventListener('click', function () {
  closeMegaMenu();
});

function closeMegaMenu() {
  document.body.classList.remove('mega--open');
  megaButton.classList.remove('active');
}

// pulldown
var pulldownElement = document.querySelectorAll('[data-pulldown]');

pulldownElement.forEach(function (el) {
  var _this = {};

  _this.el = el;
  _this.pulldownCurrentButton = el.querySelectorAll('[data-pulldown-current-button]');
  _this.pulldownCurrentText = el.querySelector('[data-pulldown-current-text]');
  _this.pulldownChangeButton = el.querySelectorAll('[data-pulldown-change-button]');
  _this.pulldownContent = el.querySelectorAll('[data-pulldown-content]');

  _this.pulldownCurrentButton.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.stopPropagation();

      if (!_this.el.classList.contains('open')) {
        _this.el.classList.add('open');
      } else {
        _this.el.classList.remove('open');
      }
    });
  });

  _this.pulldownChangeButton.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.stopPropagation();

      var pref = el.getAttribute('data-pref');

      _this.pulldownContent.forEach(function (el) {
        el.classList.remove('show');
      });

      if (document.getElementById(pref)) {
        document.getElementById(pref).classList.add('show');
        _this.pulldownCurrentText.innerHTML = pref.toUpperCase();
      }

      _this.el.classList.remove('open');
    });
  });

  document.body.addEventListener('click', function () {
    if (_this.el.classList.contains('open')) {
      _this.el.classList.remove('open');
    }
  });
});

// 
var navBtnElement = document.querySelectorAll('.c-navBtn');
navBtnElement.forEach(function (el) {
  el.addEventListener('click', function () {
    if (!document.body.classList.contains('nav--show')) {
      document.body.classList.add('nav--show');
    } else {
      document.body.classList.remove('nav--show');
    }
  });
});

//
var navPulldownElement = document.querySelector('.c-navPulldown');
var navItemProducts = document.getElementById('NavItem-Products');
var navItemProductsRect = navItemProducts.getBoundingClientRect();

navPulldownInit();
window.addEventListener('resize', navPulldownInit);

function navPulldownInit() {
  navItemProductsRect = navItemProducts.getBoundingClientRect();

  if (window.matchMedia('(min-width:640px)').matches) {
    navPulldownElement.style.width = window.innerWidth + 'px';
    navPulldownElement.style.left = -navItemProductsRect.left + 'px';
  } else {
    navPulldownElement.style.width = 'auto';
    navPulldownElement.style.left = 'auto';
  }
}